import React from 'react'
import { Box } from '@mui/material'
import { dsColorNew } from '@palette'
import { DatePickerSeeker } from '@ui-seeker/core'
import { fromIso, toIso } from 'Pages/DsRepricing/@services/dateRange'

/**
 * One calendar for one day — the single-date sibling of `DateRangeField`
 * (CU-869fkbjdh, TL plan-review 7: a pickup date is a day, not a range
 * with `from === to`, and never an `<input type="date">`).
 *
 * Wraps the app's `DatePickerSeeker` (rsuite behind a MUI FormControl,
 * the control the Admin users' expiration date already uses) exactly as
 * `DateRangeField` wraps the range picker: ISO string in and out, 40 px
 * tall like every other small input, every day selectable unless the
 * caller says otherwise (the wrapper's default refuses any day after
 * today, which is the opposite of a pickup date).
 */
const FORMAT = 'dd MMM yyyy'
const ANY_DAY = () => false

// rsuite decides the toggle's height, not MUI (`.rs-*` classes), and
// its own emotion styles beat a plain sx block — hence `!important`.
const heightSx = {
	'& .rs-picker-toggle-wrapper, & .rs-picker-toggle, & .rs-picker-input, & .rs-input': {
		minHeight: '40px !important',
		height: '40px !important',
	},
	'& .rs-picker-toggle': {
		paddingTop: '6px !important',
		paddingBottom: '6px !important',
	},
	'& .rs-picker-toggle-value, & .rs-picker-toggle-placeholder': {
		fontSize: '14px !important',
	},
}

export default function DateField({
	value, onChange,
	label = '',
	placeholder = 'Pick a day',
	cleanable = false,
	shouldDisableDate = ANY_DAY,
	width = 170,
	sx = {},
}) {
	return (
		<Box sx={{ width, flex: 'none', bgcolor: dsColorNew.white, borderRadius: 1, ...heightSx, ...sx }}>
			<DatePickerSeeker
				label={label}
				value={fromIso(value)}
				placeholder={placeholder}
				onChange={(d) => onChange(toIso(d))}
				format={FORMAT}
				cleanable={cleanable}
				placement="bottomStart"
				shouldDisableDate={shouldDisableDate}
				block/>
		</Box>
	)
}
